import React from 'react';
import { FiUser } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function AuthorBio({ lang }) {
  const t = {
    es: {
      role: 'Sobre el creador',
      name: 'Mathias Deppe',
      bio: 'Soy Mathias, diseñador instruccional, creador visual y residente en Barberà. No soy entrenador de CrossFit, pero entreno aquí. Al ver cómo la gente se frustraba con dietas complejas, utilicé mi experiencia profesional para traducir los mejores consejos de los coaches locales en una lista de la compra del Mercadona simple, visual y directa. Yo ordeno el caos, tú obtienes los resultados.'
    },
    en: {
      role: 'About the creator',
      name: 'Mathias Deppe',
      bio: "I'm Mathias, an instructional designer, visual creator, and Barberà resident. I'm not a CrossFit coach, but I train here. Seeing local athletes struggle with complex diets, I used my professional background to translate the best advice from local coaches into a simple, visual, no-nonsense Mercadona grocery list. I organize the chaos, you get the results."
    }
  }[lang];

  return (
    <div className="bg-slate-800/80 border border-slate-700 p-6 rounded-xl relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-24 h-24 bg-orange-600/5 -mr-8 -mt-8 rounded-full blur-2xl group-hover:bg-orange-600/10 transition-colors" />

      <div className="flex flex-col sm:flex-row gap-5 items-center sm:items-start relative z-10">
        <div className="shrink-0">
          <div className="relative">
            <img
              src="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/ded59f4bc1a1e49e6e28e873c79b4f37.jpg"
              alt="Portrait of Mathias Deppe, creator of Barberà del Vallès Fit"
              className="w-20 h-20 rounded-full border-2 border-orange-600 p-0.5 object-cover grayscale group-hover:grayscale-0 transition-all duration-500 shadow-xl"
            />
            <div className="absolute -bottom-1 -right-1 bg-slate-900 p-1.5 rounded-full border border-slate-700 shadow-lg">
              <SafeIcon icon={FiUser} className="text-orange-500 text-xs" />
            </div>
          </div>
        </div>

        <div className="text-center sm:text-left space-y-2">
          <div className="space-y-0.5">
            <p className="text-orange-500 font-bold uppercase tracking-[0.2em] text-[10px]">
              {t.role}
            </p>
            <h3 className="text-white font-display text-2xl font-bold tracking-tight italic">
              {t.name}
            </h3>
          </div>
          <p className="text-slate-300 text-sm leading-relaxed font-medium">
            {t.bio}
          </p>
        </div>
      </div>
    </div>
  );
}